import {Text, styled} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import {BrandThemeProvider} from '../theme';

export interface DisclaimerLayerContentProps {
  readonly closeButton: React.ReactNode;
  readonly text: string;
  readonly reference: string;
}

const closeButtonHeight = '44px';

const StyledCloseButtonWrapper = styled.div`
  position: sticky;
  top: ${(props) => props.theme.size.static100};
  right: ${(props) => props.theme.size.static100};
  margin-top: ${(props) => props.theme.size.static100};
  margin-right: ${(props) => props.theme.size.static100};
  margin-bottom: ${(props) =>
    `calc(-1 * (${props.theme.size.static100} + ${closeButtonHeight}))`};
  text-align: right;
`;

const StyledDisclaimerWrapper = styled.div`
  padding: ${(props) => props.theme.size.static250} 52px
    ${(props) => props.theme.size.static250}
    ${(props) => props.theme.size.static250};
`;

const StyledDl = styled.dl`
  display: grid;
  grid-gap: ${(props) => props.theme.size.static200}
    ${(props) => props.theme.size.static150};
  grid-template-columns: ${(props) => props.theme.size.dynamic0100} auto;
  margin: 0;
  padding: 0;
`;

const StyledDd = styled.dd`
  margin: 0;
  padding: 0;
`;

const StyledDt = styled.dt`
  margin: 0;
  padding: 0;
`;

export function DisclaimerLayerContent({
  closeButton,
  reference,
  text,
}: DisclaimerLayerContentProps): JSX.Element {
  return (
    <BrandThemeProvider theme="inverted">
      <>
        <StyledCloseButtonWrapper>{closeButton}</StyledCloseButtonWrapper>
        <StyledDisclaimerWrapper>
          <Text wordBreak staticSize>
            <StyledDl>
              <StyledDt>{reference}</StyledDt>
              <StyledDd>{text}</StyledDd>
            </StyledDl>
          </Text>
        </StyledDisclaimerWrapper>
      </>
    </BrandThemeProvider>
  );
}
